/**
 * The songs a service is edited with once suggested songs are loaded: the suggestions on their own
 * when the service is emptied first, or after its own songs otherwise, skipping any it already has.
 * @param {Array} serviceSongs - The service's songs
 * @param {Array} suggested - The suggested songs
 * @param {boolean} replace - Whether the service is emptied first
 * @returns {{ songs: Array, newSongs: Array }} - The form's songs, and those of them the service didn't have
 */
export const mergeSuggestedSongs = (serviceSongs, suggested, replace) => {
  const newSongs = suggested.filter((song) => !serviceSongs.some((serviceSong) => serviceSong?._id === song._id));

  return { songs: replace ? suggested : [...serviceSongs, ...newSongs], newSongs };
};
